import * as React from 'react';

import { useClickstreamAnalytics } from '@shared-ui/clickstream-analytics-context';
import { ViewLarge, Viewport } from '@shared-ui/viewport-context';

import { useViewTrackerContext } from 'src/common/stores/contexts/viewTracker';

import { Sidebar } from 'components/search/sidebar';

export const SidebarWrapper: React.FC<{}> = () => {
  const viewTracker = useViewTrackerContext();
  const tracker = useClickstreamAnalytics();

  return (
    <Viewport>
      <ViewLarge>
        <Sidebar tracker={tracker} viewTracker={viewTracker} />
      </ViewLarge>
    </Viewport>
  );
};
